import * as React from "react";

const SectionTitleLogo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="85.37" height="38.34" viewBox="0 0 85.37 38.34">
            <path
                d="M52.85 0c-5.3 4.86-8.55 14.77-10.17 23.7C41.07 14.77 37.82 4.86 32.51 0 11 1.63 0 12.27 0 25.16a20.85 20.85 0 004.59 13.15H17.8a23.12 23.12 0 01-4.28-13.15c0-6.95 3.34-13.34 8.94-18.46 9 8 14.8 20.69 17.54 31.64h5.37c2.74-11 8.57-23.65 17.53-31.64 5.61 5.12 8.95 11.51 8.95 18.46a23.12 23.12 0 01-4.28 13.15h13.2a20.74 20.74 0 004.6-13.15C85.37 12.27 74.33 1.63 52.85 0z"
                fill="currentColor"
            />
        </svg>
    );
};

export const sectionTitleLogoStringLight =
    "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4NS4zNyIgaGVpZ2h0PSIzOC4zNCIgdmlld0JveD0iMCAwIDg1LjM3IDM4LjM0Ij48cGF0aCBkPSJNNTIuODUgMGMtNS4zIDQuODYtOC41NSAxNC43Ny0xMC4xNyAyMy43QzQxLjA3IDE0Ljc3IDM3LjgyIDQuODYgMzIuNTEgMCAxMSAxLjYzIDAgMTIuMjcgMCAyNS4xNmEyMC44NSAyMC44NSAwIDAwNC41OSAxMy4xNUgxNy44YTIzLjEyIDIzLjEyIDAgMDEtNC4yOC0xMy4xNWMwLTYuOTUgMy4zNC0xMy4zNCA4Ljk0LTE4LjQ2IDkgOCAxNC44IDIwLjY5IDE3LjU0IDMxLjY0aDUuMzdjMi43NC0xMSA4LjU3LTIzLjY1IDE3LjUzLTMxLjY0IDUuNjEgNS4xMiA4Ljk1IDExLjUxIDguOTUgMTguNDZhMjMuMTIgMjMuMTIgMCAwMS00LjI4IDEzLjE1aDEzLjJhMjAuNzQgMjAuNzQgMCAwMDQuNi0xMy4xNUM4NS4zNyAxMi4yNyA3NC4zMyAxLjYzIDUyLjg1IDB6IiBmaWxsPSIjRjVGNUY1IiAvPjwvc3ZnPg==";

export default React.memo(SectionTitleLogo);
